import React, { SVGProps } from "react";

export default function SupGripY(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89478 5.32899C8.82495 5.32899 9.57899 4.57495 9.57899 3.64478C9.57899 2.71462 8.82495 1.96057 7.89478 1.96057C6.96462 1.96057 6.21057 2.71462 6.21057 3.64478C6.21057 4.57495 6.96462 5.32899 7.89478 5.32899ZM7.89478 4.48689C8.35986 4.48689 8.73689 4.10986 8.73689 3.64478C8.73689 3.1797 8.35986 2.80268 7.89478 2.80268C7.4297 2.80268 7.05268 3.1797 7.05268 3.64478C7.05268 4.10986 7.4297 4.48689 7.89478 4.48689Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 5.32899C13.0355 5.32899 13.7895 4.57495 13.7895 3.64478C13.7895 2.71462 13.0355 1.96057 12.1053 1.96057C11.1751 1.96057 10.4211 2.71462 10.4211 3.64478C10.4211 4.57495 11.1751 5.32899 12.1053 5.32899ZM12.1053 4.48689C12.5704 4.48689 12.9474 4.10986 12.9474 3.64478C12.9474 3.1797 12.5704 2.80268 12.1053 2.80268C11.6402 2.80268 11.2632 3.1797 11.2632 3.64478C11.2632 4.10986 11.6402 4.48689 12.1053 4.48689Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89478 9.53952C8.82495 9.53952 9.57899 8.78547 9.57899 7.85531C9.57899 6.92514 8.82495 6.1711 7.89478 6.1711C6.96462 6.1711 6.21057 6.92514 6.21057 7.85531C6.21057 8.78547 6.96462 9.53952 7.89478 9.53952ZM7.89478 8.69741C8.35986 8.69741 8.73689 8.32039 8.73689 7.85531C8.73689 7.39023 8.35986 7.0132 7.89478 7.0132C7.4297 7.0132 7.05268 7.39023 7.05268 7.85531C7.05268 8.32039 7.4297 8.69741 7.89478 8.69741Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 9.53952C13.0355 9.53952 13.7895 8.78547 13.7895 7.85531C13.7895 6.92514 13.0355 6.1711 12.1053 6.1711C11.1751 6.1711 10.4211 6.92514 10.4211 7.85531C10.4211 8.78547 11.1751 9.53952 12.1053 9.53952ZM12.1053 8.69741C12.5704 8.69741 12.9474 8.32039 12.9474 7.85531C12.9474 7.39023 12.5704 7.0132 12.1053 7.0132C11.6402 7.0132 11.2632 7.39023 11.2632 7.85531C11.2632 8.32039 11.6402 8.69741 12.1053 8.69741Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89478 13.829C8.82495 13.829 9.57899 13.0749 9.57899 12.1448C9.57899 11.2146 8.82495 10.4606 7.89478 10.4606C6.96462 10.4606 6.21057 11.2146 6.21057 12.1448C6.21057 13.0749 6.96462 13.829 7.89478 13.829ZM7.89478 12.9869C8.35986 12.9869 8.73689 12.6099 8.73689 12.1448C8.73689 11.6797 8.35986 11.3027 7.89478 11.3027C7.4297 11.3027 7.05268 11.6797 7.05268 12.1448C7.05268 12.6099 7.4297 12.9869 7.89478 12.9869Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 13.829C13.0355 13.829 13.7895 13.0749 13.7895 12.1448C13.7895 11.2146 13.0355 10.4606 12.1053 10.4606C11.1751 10.4606 10.4211 11.2146 10.4211 12.1448C10.4211 13.0749 11.1751 13.829 12.1053 13.829ZM12.1053 12.9869C12.5704 12.9869 12.9474 12.6099 12.9474 12.1448C12.9474 11.6797 12.5704 11.3027 12.1053 11.3027C11.6402 11.3027 11.2632 11.6797 11.2632 12.1448C11.2632 12.6099 11.6402 12.9869 12.1053 12.9869Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.89478 18.0395C8.82495 18.0395 9.57899 17.2855 9.57899 16.3553C9.57899 15.4251 8.82495 14.6711 7.89478 14.6711C6.96462 14.6711 6.21057 15.4251 6.21057 16.3553C6.21057 17.2855 6.96462 18.0395 7.89478 18.0395ZM7.89478 17.1974C8.35986 17.1974 8.73689 16.8204 8.73689 16.3553C8.73689 15.8902 8.35986 15.5132 7.89478 15.5132C7.4297 15.5132 7.05268 15.8902 7.05268 16.3553C7.05268 16.8204 7.4297 17.1974 7.89478 17.1974Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 18.0395C13.0355 18.0395 13.7895 17.2855 13.7895 16.3553C13.7895 15.4251 13.0355 14.6711 12.1053 14.6711C11.1751 14.6711 10.4211 15.4251 10.4211 16.3553C10.4211 17.2855 11.1751 18.0395 12.1053 18.0395ZM12.1053 17.1974C12.5704 17.1974 12.9474 16.8204 12.9474 16.3553C12.9474 15.8902 12.5704 15.5132 12.1053 15.5132C11.6402 15.5132 11.2632 15.8902 11.2632 16.3553C11.2632 16.8204 11.6402 17.1974 12.1053 17.1974Z"
        fill="currentColor"
      />
    </svg>
  );
}
